import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const memberCategoryApi = createApi({
    reducerPath: "memberCategoryApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["MemberCategory"],
    endpoints: (builder) => ({
        // Get all Member Categories
        getMemberCategories: builder.query({
            query: () => "/member-categories",
            transformResponse: (response) => response.data || response,
            providesTags: ["MemberCategory"],
        }),

        // Get a single Member Category
        getMemberCategoryById: builder.query({
            query: (id) => `/member-categories/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: "MemberCategory", id }],
        }),

        // Create a new Member Category
        createMemberCategory: builder.mutation({
            query: (memberCategory) => ({
                url: `/member-categories`,
                method: "POST",
                body: memberCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["MemberCategory"],
        }),

        // Update an existing Member Category
        updateMemberCategory: builder.mutation({
            query: ({ id, ...memberCategory }) => ({
                url: `/member-categories/${id}`,
                method: "PUT",
                body: memberCategory,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["MemberCategory"],
        }),

        // Delete an existing Member Category
        deleteMemberCategory: builder.mutation({
            query: (id) => ({
                url: `/member-categories/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["MemberCategory"],
        }),
    }),
});

export const {
    useGetMemberCategoriesQuery,
    useGetMemberCategoryByIdQuery,
    useCreateMemberCategoryMutation,
    useUpdateMemberCategoryMutation,
    useDeleteMemberCategoryMutation,
} = memberCategoryApi;